exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".register-container{border-radius:5px;-moz-border-radius:5px;background-clip:padding-box;margin:180px auto;width:350px;padding:35px 35px 15px;background:#fff;border:1px solid #eaeaea;box-shadow:0 0 10px #cac6c6;z-index:99;.title{margin:0 auto 40px;color:#505458}.remember{margin:0 0 35px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75c3a756","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Register.vue
// module id = 255
// module chunks = 0